/**
 * @fileoverview A function that renders the site routes.
 *
 * @example
 * renderSitesRoutes()
 */

import { Navigate, Route } from 'react-router-dom'
import { Layout } from '../components/Layout'
import { SiteCard } from '../components/admin/SiteCard'
import { SiteList } from '../components/admin/SiteList'
import { StaffTab } from '../components/admin/tabs/Staff'
import { useAppDispatch } from '../hooks/useRedux'
import { sitesApi } from '../services/sites'

/**
 * @function renderSitesRoutes
 * @description Renders the site routes.
 * @returns {React.ReactNode} - The site routes.
 */
export function renderSitesRoutes() {
    const dispatch = useAppDispatch()

    return (
        <Route path="sites" element={<Layout />}>
            <Route
                index
                element={<SiteList />}
                loader={async () => {
                    const sites = dispatch(sitesApi.endpoints.getSites.initiate())
                    const total = dispatch(sitesApi.endpoints.getSitesCount.initiate())
                    return {
                        sites: await sites.unwrap(),
                        total: await total.unwrap(),
                    }
                }}
            />
            <Route
                path=":siteId"
                element={<SiteCard />}
                loader={async ({ params }) => {
                    const sites = dispatch(sitesApi.endpoints.getSiteById.initiate(params.siteId))
                    return {
                        site: await sites.unwrap(),
                    }
                }}
            >
                <Route path="staff" element={<StaffTab />} />
                <Route index element={<Navigate to="staff" replace />} />
            </Route>
        </Route>
    )
}
